import { Component, Input, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableFilter, FilterChangeEvent } from '../../models/table.interface';
import { DateRangePickerComponent, DateRange } from '../date-range-picker/date-range-picker';

@Component({
  selector: 'app-table-filters',
  standalone: true,
  imports: [CommonModule, FormsModule, DateRangePickerComponent],
  templateUrl: './table-filters.html',
  styleUrls: ['./table-filters.scss']
})
export class TableFiltersComponent {
  @Input() filters: TableFilter[] = [];
  @Input() initialFilters: { [key: string]: any } = {};
  @Output() filterChange = new EventEmitter<FilterChangeEvent>();

  @ViewChildren(DateRangePickerComponent) datePickers!: QueryList<DateRangePickerComponent>;

  filterValues: { [key: string]: any } = {};
  dropdownStates: { [key: string]: boolean } = {};
  selectedLabels: { [key: string]: string } = {};

  ngOnInit(): void {
    // Check if options exist and select the first one
    this.filters.forEach(filter => {
      const initialVal = this.initialFilters[filter.key];

      if (initialVal !== undefined) {
        this.filterValues[filter.key] = initialVal;
      } else if (filter.type !== 'daterange') {
        this.onFilterChange(filter.key, '');
      }

      // Initialize dropdown states
      if (filter.type === 'dropdown') {
        this.dropdownStates[filter.key] = false;
        this.selectedLabels[filter.key] = filter.placeholder || 'All';
      }
    });

  }

  onFilterChange(filterKey: string, value: any): void {
    this.filterValues[filterKey] = value;
    this.filterChange.emit({ filterKey, filterValue: value });
  }

  onDateRangeChange(filterKey: string, dateRange: DateRange): void {
    this.filterValues[filterKey] = dateRange;
    this.filterChange.emit({ filterKey, filterValue: dateRange });
  }

  toggleDropdown(filterKey: string): void {
    // Close all other dropdowns
    Object.keys(this.dropdownStates).forEach(key => {
      if (key !== filterKey) {
        this.dropdownStates[key] = false;
      }
    });
    // Toggle current dropdown
    this.dropdownStates[filterKey] = !this.dropdownStates[filterKey];
  }

  selectOption(filterKey: string, value: any, label: string): void {
    this.filterValues[filterKey] = value;
    this.selectedLabels[filterKey] = label;
    this.dropdownStates[filterKey] = false;
    this.onFilterChange(filterKey, value);
  }

  getSelectedLabel(filter: TableFilter): string {
    /*pre selected value , filtering from account summary widget*/
    const val = this.filterValues[filter.key];
    if (val && filter.options) {
      const opt = filter.options.find(o => o.value === val);
      if (opt) return opt.label;
    }
    return this.selectedLabels[filter.key] || filter.placeholder || 'All';
  }

  clearFilters(): void {
    // Reset all filter values to empty strings
    this.filters.forEach(filter => {
      this.filterValues[filter.key] = '';
      if (filter.type === 'dropdown') {
        this.selectedLabels[filter.key] = filter.placeholder || 'All';
      }
      this.filterChange.emit({ filterKey: filter.key, filterValue: '' });
    });

    // Reset date pickers
    this.datePickers.forEach(picker => picker.reset());
  }

  hasActiveFilters(): boolean {
    return Object.values(this.filterValues).some(val => val && val !== '');
  }
}
